import { render, staticRenderFns } from "./warnPage.vue?vue&type=template&id=2d99d6ae&scoped=true"
import script from "./warnPage.vue?vue&type=script&lang=js"
export * from "./warnPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d99d6ae",
  null
  
)

export default component.exports